import {decorate, observable} from 'mobx';
import {faList} from '@fortawesome/free-solid-svg-icons';
import {BaseModel} from './base';

export class BatchGeneratorFunction extends BaseModel {
  static faIcon = faList;

  searchableProperties = ['id', 'material.no', 'material.name', 'customFunction.label'];

  populateAttributesFromStore(rootStore) {
    super.populateAttributesFromStore(rootStore);
    this.material = rootStore.materialStore.getById(this.materialId);
    this.customFunction = rootStore.customFunctionStore.getById(this.customFunctionId);
  }
}

decorate(BatchGeneratorFunction, {
  material: observable,
  materialId: observable,
  customFunction: observable,
  customFunctionId: observable,
});
